import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

/** Holds the title's place while it loads, rather than naming a quote and then renaming it. */
const LOADING_QUOTE_LABEL = '...'

/** For good, if that quote can't be read at all - a banner naming it still has to say something. */
const FALLBACK_QUOTE_LABEL = 'Another quote'

/**
 * Loads another quote so a banner can name it: its title, or its number when it has no title.
 * Nothing is loaded while `quoteId` is unset.
 */
export const useOtherQuoteLabel = ({
  quoteId,
  staleTime
}: {
  quoteId: string | undefined
  staleTime?: number
}): string => {
  const quoteQuery = useQuery(
    dashboard20240730Client.getQuote,
    { id: quoteId ?? '' },
    { enabled: Boolean(quoteId), staleTime }
  )

  return (
    quoteQuery.data?.title ||
    quoteQuery.data?.quoteNumber ||
    (quoteQuery.isLoading ? LOADING_QUOTE_LABEL : FALLBACK_QUOTE_LABEL)
  )
}
